
import { API_END_POINT } from "../../../constants";
import { Button, Modal } from "react-bootstrap";
import axios from "axios";
import '@progress/kendo-theme-default/dist/all.css';
import '../../../components/Style/app.css';
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { OrderHistory } from "../../../models/transaction/orderhistory-model";
import { getDataWithToken, getEndPoint, postData } from "../../../Utils/network.client";
import { Product, Receipt } from "../../../models/transaction/cardorder-model";
import { useGetPaymentMode } from "../../../apiclient/common/useGetPaymentModeApi";
import EditIcon from "../../../assets/images/edit";
import { useGetDroppingPoint } from "../../../apiclient/party/useGetDropingPointApi";
import ZoneCounterModel from "../../../models/transaction/zonecounter-model";
import { useGetCompanyDetails } from "../../../apiclient/master/useGetCompanydetailsApi";
import { useGetCompanyDetailsList } from "../../../apiclient/transaction/useGetCompanyforCardOrderApi";


interface CardOrderEditProps {
  data: ZoneCounterModel;
  onClose?: () => void;
  setActivePage: (page: "list" | "entry") => void;

}
const CardOrderEntryPage: React.FC<CardOrderEditProps> = ({ data, setActivePage }) => {


  const location = useLocation();
  const zoneData = data;
  console.log("Zone", zoneData);

  let orderZoneId = zoneData.zoneId;
  let orderCounterId = zoneData.counterId;

  //orderHistoryDataList
  const [orderHistoryList, setOrderHistoryList] = useState<OrderHistory[]>([]);

  const [selectedItem, setSelectedItem] = useState(null);

  //cardCustomer
  const [loadingDetails, setLoadingDetails] = useState<boolean>(false);
  const [cardCustomerCode, setCardCustomerCode] = useState<string>("");
  const [cardCustomerName, setCardCustomerName] = useState<string>("");
  const [droppingPointName, setDroppingPointName] = useState<string>("");
  const [mobileNo, setMobileNo] = useState<string>("");
  const [orderDate, setOrderDate] = useState<string>("");
  const [fetchedCardProductList, setFetchedCardProductList] = useState<Product[]>([])
  const [receiptList, setReceiptList] = useState<Receipt[]>([]);
  const [agentList, setAgentList] = useState<string>("")
  const [customerList, setCustomerList] = useState<string>("")
  const [daysDifference, setDaysDifference] = useState<number>();
  const [totalAmount, setTotalAmount] = useState<number>(0);
  const [showModal, setShowModal] = useState(false);
  const [showGrid, setShowGrid] = useState(false);
  const [isGetClicked, setIsGetClicked] = useState(false);

  const [orderNumber, setorderNumber] = useState(0);
  const [cardNumber, setCardNumber] = useState<string>('');
  const [walletAmountUsed, setWalletAmountUsed] = useState(0);
  const [orderMonth, setOrderMonth] = useState<string>("");
  const [droppingPointId, setdroppingPointId] = useState(0);
  const [agentId, setAgentId] = useState(0);
  const [categoryId, setCategoryId] = useState(0);
  const [zoneId, setZoneId] = useState(0);
  const [routeId, setRouteId] = useState(0);
  const [counterId, setCounterId] = useState(0);
  const [cardCustomerId, setCardCustomerId] = useState(0);
  const [isDespatched, setisDespatched] = useState(false);
  const [discountAmount, setdiscountAmount] = useState(0);

  //receipt
  const [modeOfPayment, setModeOfPayment] = useState<number>(0);
  const [reference, setReference] = useState('');
  const [receivedAmount, setReceivedAmount] = useState('');
  const [receiptId, setReceiptId] = useState<number>(0);


  //show booth change 
  const [isBoothSaved, setIsBoothSaved] = useState(false);
  const [isCustomerSaved, setIsCustomerSaved] = useState(false);
  const [showContainer, setShowContainer] = useState(false);
  /*   const [cardCustomerId,setCardCustomerId] = useState<number>(0); */
  const [droppingPoint, setDroppingPoint] = useState<number>(0);

  const [date1, setDate1] = useState("");
  const [date2, setDate2] = useState("");
  const [orderDate1, setOrderDate1] = useState<string>("");

  const [dropingPointData, setDropingPointData] = useState<{ value: string; label: string }[]>([]);
  const { data: fetchedDropingPoint } = useGetDroppingPoint();

  const { data: fetchedCompanyDetails } = useGetCompanyDetailsList();
 /*  console.log("cardorder",fetchedCompanyDetails); */

  useEffect(() => {
    if (fetchedDropingPoint) {
      const mappedDropingPoint = fetchedDropingPoint.map((dropingpoint: any) => ({
        value: dropingpoint.droppingpointId,
        label: dropingpoint.code,
      }));
      setDropingPointData(mappedDropingPoint);
    }
  }, [fetchedDropingPoint]);
  


  useEffect(() => {
   /*  alert(fetchedCompanyDetails); */
    console.log("card",fetchedCompanyDetails);
    const today = new Date();
    const days = today.getDate().toString().padStart(2, '0');
    const ordermonth = today.toLocaleString('default', { month: 'short' }).toUpperCase(); // Get short month (e.g., JAN)
    const month = (today.getMonth() + 1).toString().padStart(2, '0');
    const year = today.getFullYear();

    const formatted1Date = `${year}-${month}-${days}`;
    const dateformat = `${days}-${month}-${year}`;
    const formattedDate = today.toISOString().split('T')[0]; // Format as YYYY-MM-DD
    setOrderDate(formatted1Date);
    setOrderDate1(dateformat);
    setOrderMonth(ordermonth);

    if (!fetchedCompanyDetails || !Array.isArray(fetchedCompanyDetails) || fetchedCompanyDetails.length === 0) {
      return;
    }
    const cardorders = fetchedCompanyDetails[0].noOfCardOrder;
    const cardSalesStartDay = fetchedCompanyDetails?.[0]?.cardSalesStartDay;
    const cardSalesEndDay = fetchedCompanyDetails?.[0]?.cardSalesEndDay;
    const cardSalesStartDay2 = fetchedCompanyDetails?.[0]?.cardSalesStartDay2;
    const cardSalesStartDay3 = fetchedCompanyDetails?.[0]?.cardSalesStartDay3;
    let now = new Date();
    const day = cardSalesStartDay;
    if (cardorders == 1) {
      const dt = new Date(now.getFullYear(), now.getMonth(), day);
      if (now < dt) {
        setDate1(dt.toLocaleDateString("en-GB").replaceAll('/', '-'));
        const end = new Date(dt);
        end.setMonth(end.getMonth() + 1);
        end.setDate(end.getDate() - 1);
        setDate2(end.toLocaleDateString("en-GB").replaceAll('/', '-'));
      } else {
       /*  const next = new Date(dt); */
        const next = new Date(now.getFullYear(), now.getMonth() + 1, 1); 
        const end = new Date(next.getFullYear(), next.getMonth() + 1, 0);
        //setDate1(next.toISOString().split("T")[0]);
        //setDate1(next.toLocaleDateString("en-GB").replaceAll('/', '-'));
        setDate1(formatDate(next));
        console.log('date1',date1);
       // setDate2(end.toISOString().split("T")[0])
        //setDate2(end.toLocaleDateString("en-GB").replaceAll('/', '-'));
        setDate2(formatDate(end));
        console.log('date2',date2);
      }
    } else if (cardorders === 2) {
      let dt = new Date(now.getFullYear(), now.getMonth(), (cardSalesStartDay));
      if (now < dt) {
       // setDate1(dt.toISOString().split("T")[0]);
       setDate1(dt.toLocaleDateString("en-GB").replaceAll('/', '-'));
        const end = new Date(dt);
        end.setMonth(end.getMonth() + 1);
        end.setDate(end.getDate() - 1);
        setDate1(end.toLocaleDateString("en-GB").replaceAll('/', '-'));
       // setDate2(end.toISOString().split("T")[0]);
        return;
      }

      dt = new Date(now.getFullYear(), now.getMonth(), (cardSalesEndDay));
      if (now < dt) {
        setDate1(dt.toLocaleDateString("en-GB").replaceAll('/', '-'));
        if (cardSalesStartDay === 1) {
          const end = new Date(now.getFullYear(), now.getMonth() + 1, 0);
          setDate2(end.toLocaleDateString("en-GB").replaceAll('/', '-'));
        } else {
          const end = new Date(dt);
          end.setMonth(end.getMonth() + 1);
          end.setDate(end.getDate() - 1);
          setDate2(end.toLocaleDateString("en-GB").replaceAll('/', '-'));
        }
        return;
      }

      const dayone = new Date(now.getFullYear(), now.getMonth() + 1, (cardSalesStartDay));
      const end = new Date(dayone.getFullYear(), dayone.getMonth() + 1, 0);
      setDate1(dayone.toLocaleDateString("en-GB").replaceAll('/', '-'));
      setDate2(end.toLocaleDateString("en-GB").replaceAll('/', '-'));
    } else if (cardorders === 3) {
      let dt = new Date(now.getFullYear(), now.getMonth(), (cardSalesStartDay));
      if (now < dt) {
        setDate1(dt.toLocaleDateString("en-GB").replaceAll('/', '-'));
        const end = new Date(dt);
        end.setMonth(end.getMonth() + 1);
        end.setDate(end.getDate() - 1);
        setDate2(end.toLocaleDateString("en-GB").replaceAll('/', '-'));
        return;
      }

      dt = new Date(now.getFullYear(), now.getMonth(), (cardSalesEndDay));
      if (now < dt) {
        setDate1(dt.toLocaleDateString("en-GB").replaceAll('/', '-'));
        if (cardSalesStartDay === 1) {
          const end = new Date(now.getFullYear(), now.getMonth() + 1, 0);
          setDate2(end.toLocaleDateString("en-GB").replaceAll('/', '-'));
        } else {
          setDate2(new Date(now.getFullYear(), now.getMonth() + 1, (cardSalesStartDay3)).toLocaleDateString("en-GB").replaceAll('/', '-'));
        }
        return;
      }

      dt = new Date(now.getFullYear(), now.getMonth(), (cardSalesStartDay2));
      if (now < dt) {
        setDate1(dt.toLocaleDateString("en-GB").replaceAll('/', '-'));
        if (cardSalesStartDay === 1) {
          const end = new Date(now.getFullYear(), now.getMonth() + 1, 0);
          setDate2(end.toLocaleDateString("en-GB").replaceAll('/', '-'));
        } else {
          const end = new Date(dt);
          end.setMonth(end.getMonth() + 1);
          end.setDate(end.getDate() - 1);
          setDate2(end.toLocaleDateString("en-GB").replaceAll('/', '-'));
        }
        return;
      } else {
        setDate1(new Date(now.getFullYear(), now.getMonth() + 1, (cardSalesStartDay2)).toLocaleDateString("en-GB").replaceAll('/', '-'));
        setDate2(new Date(now.getFullYear(), now.getMonth() + 1, (cardSalesStartDay3)).toLocaleDateString("en-GB").replaceAll('/', '-'));
      }
    }




    // const today = new Date();
    // const day = today.getDate().toString().padStart(2, '0');
    // const ordermonth = today.toLocaleString('default', { month: 'short' }).toUpperCase(); // Get short month (e.g., JAN)
    // const month = (today.getMonth() + 1).toString().padStart(2, '0');
    // const year = today.getFullYear();

    // const formatted1Date = `${year}-${month}-${day}`;
    // const formattedDate = today.toISOString().split('T')[0]; // Format as YYYY-MM-DD
    // setOrderDate(formatted1Date);
    // setOrderMonth(ordermonth);

    // let startDate, endDate;

    // console.log("tdy", today.getDate())
    // if (today.getDate() >= 1 && today.getDate() <= 15) {
    //   startDate = new Date(year, today.getMonth(), 16);
    //   endDate = new Date(year, today.getMonth() + 1, 15);
    //   console.log("sdate", startDate);
    //   console.log("edate", endDate)
    // } else {
    //   startDate = new Date(year, today.getMonth() + 1, 16);
    //   endDate = new Date(year, today.getMonth() + 2, 15);
    //   console.log("sdate1", startDate);
    //   console.log("edate1", endDate)
    // }

    // const sday = startDate.getDate().toString().padStart(2, '0');
    // const smonth = (startDate.getMonth() + 1).toString().padStart(2, '0');
    // const syear = startDate.getFullYear();
    // const eday = endDate.getDate().toString().padStart(2, '0');
    // const emonth = (endDate.getMonth() + 1).toString().padStart(2, '0');
    // const eyear = endDate.getFullYear();
    // const startFormattedDate = `${sday}-${smonth}-${syear}`;
    // const endFormattedDate = `${eday}-${emonth}-${eyear}`;

    // setStartDate(startFormattedDate);
    // setEndDate(endFormattedDate);
    // console.log("Start Date: ", startFormattedDate);
    // console.log("End Date: ", endFormattedDate);

    // const differenceInTime = endDate.getTime() - startDate.getTime(); // Difference in milliseconds
    // const differenceInDays = differenceInTime / (1000 * 3600 * 24); // Convert from milliseconds to days
    // setDaysDifference(differenceInDays + 1);
    // console.log("days", daysDifference);

  }, [fetchedCompanyDetails]);


  const formatDate = (date:any) => {
    const dd = String(date.getDate()).padStart(2, '0');
    const mm = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const yyyy = date.getFullYear();
    return `${dd}-${mm}-${yyyy}`;
  };

  // mode payment for dropdown
  const [modePayment, setmodePaymentData] = useState<{ value: string; label: string }[]>([]);
  const { data: fetchedModePayment } = useGetPaymentMode();

  useEffect(() => {
    if (fetchedModePayment) {
      const mappedmodepayment = fetchedModePayment.map((modepayment: any) => ({
        value: modepayment.id,
        label: modepayment.name,
      }));
      setmodePaymentData(mappedmodepayment);
    }
  }, [fetchedModePayment]);

  const handleModedropdownChange = (event: { target: { value: any; }; }) => {
    setModeOfPayment(event.target.value);
    // alert(event.target.value) // Update selected option
  };

  const handledroppingpointdropdownChange = (event: { target: { value: any; }; }) => {
    setDroppingPoint(event.target.value);
    // alert(event.target.value) // Update selected option
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;

    if (name === 'CustomerCode') {
      setCardCustomerCode(value);
    } else if (name === 'mobileNo') {
      setMobileNo(value);
    } else if (name === 'reference') {
      setReference(value);
    } else if (name === 'receivedAmount') {
      setReceivedAmount(value);
    }
  };


  const handleGetButtonClick = async () => {
    if (cardCustomerCode || mobileNo) {
      setLoadingDetails(true);
      try {
        //mobileNo ? setMobileNo(mobileNo) : setMobileNo(null);
        // cardCustomerCode ? setCardCustomerCode(cardCustomerCode) : setCardCustomerCode(null);
        setMobileNo(mobileNo || null);
        setCardCustomerCode(cardCustomerCode || null);
        await fetchData(cardCustomerCode, mobileNo);
      } catch (error) {
        console.error("Error fetching product price details:", error);
      } finally {
        setLoadingDetails(false);
      }
    } else {
      alert("Please select a customercode or mobile number.");
    }
  };

  const fetchData = async (customerCode: string, mobileNo: string) => {
    let getProductUrl = '';
    if (cardCustomerCode) {
      getProductUrl = getEndPoint(API_END_POINT.ORDER) + `/api/CardOrder/GetProductsByCardCutomerCode/${orderDate}/${customerCode}/${null}`;
    } else {
      getProductUrl = getEndPoint(API_END_POINT.ORDER) + `/api/CardOrder/GetProductsByCardCutomerCode/${orderDate}/${null}/${mobileNo}`;
    }
    // Base URL
    // getProductUrl = getEndPoint(API_END_POINT.ORDER) + `/api/CardOrder/GetProductsByCardCutomerCode/${orderDate}/${cardCustomerCode}/${mobileNo}`; 
    console.log("1", getProductUrl)
    try {
      const response = await getDataWithToken<any>(getProductUrl)
      console.log(response);
      const product = response?.data?.result?.products || [];
      const receipt = response?.data?.result?.receipt || [];

      setReceiptList(receipt);
      if (product.length) {
        //alert("b")
        const CustomerDetails = product[0];
        const droppingPointId = CustomerDetails?.droppingpointId;
        const agentId = CustomerDetails?.agentId;
        const categoryId = CustomerDetails?.categoryId;
        const zoneId = CustomerDetails?.zoneId;
        const cardCustomerId = CustomerDetails?.cardCustomerId;
        const routeId = CustomerDetails?.routeId;
        const counterId = CustomerDetails?.counterId;

        console.log("product", product);
        // Set the corresponding state values
        setdroppingPointId(droppingPoint);
        setAgentId(agentId);
        setCategoryId(categoryId);
        setZoneId(zoneId);
        setCounterId(counterId);
        setCardCustomerId(cardCustomerId);
        setRouteId(routeId);
        setCardCustomerName(CustomerDetails.cardCustomerName);
        setDroppingPoint(CustomerDetails?.droppingpointId);

        /*  setIsSaved(false); */
        setAgentList(
          `Booth       : ${CustomerDetails.droppingPointCode} - ${CustomerDetails.droppingPointName} \nAgent     : ${CustomerDetails.agentCode} - ${CustomerDetails.agentName}\nMobile    : ${CustomerDetails.agentMobile} \nAddress: ${CustomerDetails.agentAddress}`
        )
        setCustomerList(`${CustomerDetails.cardCustomerName}  ${CustomerDetails.cardCustomerMobile}              Cust.Type   : Customer \nAddress : ${CustomerDetails.cardCustomerAddress}                   Cust.Wallet : 0`);
        setFetchedCardProductList(product.map((item: any) => ({
          ...item,
          inEdit: true,
          amount: ((Number(item.morningQty) + Number(item.eveningQty)) * Number(item.rate.basicRate)) * daysDifference,
        })));
        // setFetchedCardProductList(product);
        calculateTotalAmount(product);
        /* setReceiptList(receipt); */
        console.log("rs", receipt)


        if (receipt[0]?.orderAmount) {
          setTotalAmount(receipt[0]?.orderAmount);
        }
        else {
          setTotalAmount(0.00);
        }
        setShowGrid(true);
        setIsGetClicked(true);
        setIsBoothSaved(true);
        setIsCustomerSaved(true);
      } else {
        setShowGrid(false);
        setCardCustomerCode('');
        setModeOfPayment(0);
        setReference('');
        setReceivedAmount('');
        setTotalAmount(0);
        alert("No Data Found");
      }

      if (receipt.length) {
        setModeOfPayment(receipt[0]?.paymentModeId);
        setReference(receipt[0]?.reference);
        setReceivedAmount(receipt[0]?.receivedAmount);
        setReceiptId(receipt[0]?.receiptId);
      }
      else {
        setModeOfPayment(0);
        setReference('');
        setReceivedAmount('');
        setReceiptId(0);
      }

    } catch (error) {
      console.error('Error fetching data:', error);
      setShowGrid(false);
    }
  };

  useEffect(() => {
    if (orderDate) {
      getCardOrderHistoryList();  // Call API after orderDate is set
    }
  }, [orderDate]);


  const getCardOrderHistoryList = async () => {
    try {
      const getCardOrderHistoryUrl = getEndPoint(API_END_POINT.ORDER) + `/api/CardOrder/GetCardOrderHistoryList/${zoneData.currentDate}/${zoneData.zoneId}/${zoneData.counterId}/${1}`; // Base URL
      /* const getOrderHistoryUrl = getEndPoint(API_END_POINT.ORDER) + "/api/OrderMain/GetOrderHistoryList"; */
      const response = await getDataWithToken<any>(getCardOrderHistoryUrl)
      //alert(JSON.stringify(response.data.result));
      console.log("history", response);
      const orderHistory = response?.data?.result || [];

      console.log("history1", orderHistory);
      setOrderHistoryList(orderHistory);
      //setLoading(false);
    }
    catch (error) {
      console.error('Error fetching data:', error);
      //setShowGrid(false);
    }
  }



  const handleCloseModal = () => {
    setShowModal(false);
  };

  const calculateTotalAmount = (data: any[]) => {
    console.log("Data:", data);
    const total = data.reduce((sum, item) => {
      const amount = parseFloat(item.amount);
      console.log("sum:", amount);
      return sum + (isNaN(amount) ? 0 : amount);
    }, 0);
    console.log("total a:", total)
    setTotalAmount(total);
    setReceivedAmount(total.toFixed(2));
  };



  const totalOrderAmount = orderHistoryList.reduce((sum, item) => sum + item.receiptAmount, 0).toFixed(2);
  const orderCount = orderHistoryList.length;

  const handleEdit = async (item: any) => {
    //alert("a");
    setSelectedItem(item); // Set selected item for editing
    console.log('Editing item:', item);
    setCardCustomerCode(item.cardCustomerCode);
    console.log(cardCustomerCode);
    setMobileNo(item.mobileNo);
    console.log(mobileNo);
    setModeOfPayment(item.name);
    setReference(item.Reference);
    setReceivedAmount(item.receivedAmount);
    await fetchData(cardCustomerCode, mobileNo);
  };


  const handleQtyChange = (e: React.ChangeEvent<HTMLInputElement>, index: number, type: string) => {
    const updatedList = [...fetchedCardProductList];
    const updatedItem = updatedList[index];

    let value = Number(e.target.value);
    if (isNaN(value) || value < 0) {
      value = 0;  // Set to 0 if invalid or negative
    }
    if (type === 'morningQty') {
      updatedItem.morningQty = value;
    } else if (type === 'eveningQty') {
      updatedItem.eveningQty = value;
    }
    updatedItem.amount = ((Number(updatedItem.morningQty) + Number(updatedItem.eveningQty)) * Number(updatedItem.rate.basicRate)) * daysDifference;
    //updatedItem.amount = amount * daysDifference
    updatedList[index] = updatedItem;

    setFetchedCardProductList(updatedList);
    calculateTotalAmount(updatedList);
  };

  /*   useEffect(() => {
      fetchData();
    }, []); */

  const handleConfirmOrder = () => {
    const isValidOrder = fetchedCardProductList.some(product =>
      product.morningQty > 0 || product.eveningQty > 0
    );
    if (isValidOrder) {
      // alert("a")
      if (modeOfPayment) {

        if (reference == "" && modeOfPayment == 1 || reference) {
          if (parseFloat(receivedAmount) >= totalAmount) {
            setLoadingDetails(false);
            setShowModal(true);
          }
          else {
            alert("Received Amount less than totalAmount ");
          }
        }
        else {
          alert("Reference should not be empty.");
        }
      } else {
        alert("Please select a valid Payment Mode");
      }
    }
    else {
      alert("Both Morning Quantity and Evening Quantity should be greater than 0.");
      /*   setCardCustomerCode('');
        setMobileNo(''); */
    }
  };

  const handleProceedOrder = async () => {
    setLoadingDetails(true);
    try {
      const CardOrderLine = fetchedCardProductList.map(product => ({
        productId: product.productId,
        productname: product.productName,
        basicrateperunit: product.rate.basicRate,
        morningquantitypackets: product.morningQty,
        eveningquantitypackets: product.eveningQty,
        amount: product.amount,
        orderline_mid: product.orderLine_MId,
        orderline_eid: product.orderLine_EId,
        ordermain_id: product.orderMain_MId,
        droppingpointid: product.droppingpointId,
        maingroupid: product.mainGroupId,
        subgroupid: product.subGroupId,
        productshortname: product.productShortName,
        cgstpercentage: product.cgstPercentage,
        sgstpercentage: product.sgstPercentage,
        igstpercentage: product.igstPercentage,
        cgstrateperunit: product.rate.cgst,
        sgstrateperunit: product.rate.sgst,
        igstrateperunit: product.rate.igst,
        unitqty: product.unitQty,
        unitfactor: product.unitFactor,
        packetpertray: product.packetPerTray,
        orderNumber,
        cardNumber,
        date1,
        date2,
        orderMonth,
        agentId,
        categoryId,
        zoneId: orderZoneId,
        routeId,
        counterId: orderCounterId,
        cardCustomerId,
        isDespatched,
        walletAmountUsed,
        totalamount: totalAmount.toFixed(2),
        receivedAmount,
        discountAmount,
        paymentstatus: 1,
        ordermode: "1",
        orderDate

      }));

      const CardOrderReceipt = {
        receiptId: receiptId,
        paymentmode: modeOfPayment,
        receiptamount: receivedAmount,
        paymenttype: 3,
        counterId: orderCounterId,
        droppingPointId,
        agentId,
        reference: reference,
        receiptDate: orderDate,
        orderAmount: totalAmount.toFixed(2),
        paymentstatus: 1,
        receiptNumber: "REC001"
      };

      // alert(JSON.stringify(OrderLine));
      // alert(JSON.stringify(OrderReceipt));
      const orderRequest = {
        CardOrderLine,
        CardOrderReceipt,
      };

      //console.log(JSON.stringify(orderRequest));
      // console.log(getEndPoint(API_END_POINT.ORDER) + "/api/CardOrder/SaveCardOrder");


      /* return; */ // Stop execution if validation fails
      /*  const response = await axios.post(getEndPoint(API_END_POINT.ORDER) + "/api/CardOrder/SaveCardOrder", JSON.stringify(orderRequest),
         {
           headers: {
             "Content-Type": "application/json"
           }
         }
       ); */
      const response = await postData<any>(API_END_POINT.ORDER,
        "CardOrder/SaveCardOrder",
        "POST",
        "application/json",
        orderRequest,
      );
      if (response.status === 200) {
        setLoadingDetails(false);
        alert("Order Confirmed Successfully!");
        // setFetchedProductList([]);
        setFetchedCardProductList(prevProductList =>
          prevProductList.map(product => ({
            ...product,
            morningQty: 0,
            eveningQty: 0,
            amount: 0
          }))
        );
        setModeOfPayment(0);
        setReference('');
        setReceivedAmount('');
        setTotalAmount(0);
        /*  setReceiptList(''); */
        setCardCustomerCode('');
        setIsBoothSaved(false);
        setIsCustomerSaved(false);
        /*  setIsGetClicked(false); */
        //setAgentList('');
        // setCustomerList('');
        getCardOrderHistoryList();

      } else {
        alert("Failed to Confirm the Order.");
      }



    } catch (error: any) {
      //console.error("Error confirming order:", error);
      if (error.response) {
        console.error("API Response Error:", error.response.data);
      }

      // alert("Error confirming the order.");
      // alert(JSON.stringify(error));
    } finally {
      setShowModal(false); // Close the modal
    }
  };

  const handleChangeBooth = () => {
    setCardCustomerCode(cardCustomerCode);
    setCardCustomerName(cardCustomerName);
    setDroppingPoint(droppingPoint);
    // alert(droppingPoint);
    setShowContainer(true);
    console.log("Container should now be visible: ", showContainer);
  };

  const handleClose = () => {
    setShowContainer(false); // Hide the modal/container
  };

  const handleBoothUpdate = async () => {
    setShowContainer(false);
    //  alert(cardCustomerId);
    // alert(droppingPoint);
    const orderRequest = {
      cardCustomerId: cardCustomerId,
      droppingPointId: droppingPoint
    }

    // const updateDroppingPointUrl = getEndPoint(API_END_POINT.ORDER) + "/api/CardOrder/UpdateDroppingPointinCardCustomer"; // Base URL

    try {
      const response = await postData<any>(API_END_POINT.ORDER,
        "CardOrder/UpdateDroppingPointinCardCustomer",
        "POST",
        "application/json",
        orderRequest,
      );
      // Send data directly in the body, not inside `params`
      /*   const response = await axios.post(updateDroppingPointUrl, {
          cardCustomerId: cardCustomerId,
          droppingPointId: droppingPoint
        }); */
      const updateBooth = response?.data?.result;
      console.log("updateBooth", updateBooth);
      setAgentList(
        `Booth       : ${updateBooth.droppingPointCode} - ${updateBooth.droppingPointName} \nAgent     : ${updateBooth.agentCode} - ${updateBooth.agentName}\nMobile    : ${updateBooth.agentMobile} \nAddress: ${updateBooth.agentAddress}`
      )

    } catch (error) {
      console.error("Error calling API:", error);
    }
    /* try{
      const updateDroppingPointUrl = getEndPoint(API_END_POINT.ORDER) + "/api/CardOrder/UpdateDroppingPointinCardCustomer"; // Base URL
      const response = await axios.post(updateDroppingPointUrl, {
        params: { CustomerId: cardCustomerId, droppingId: droppingPoint},
      });
    
      console.log(response);
  
    }
    catch{

    } */
  }

  return (
    (
      <>
        <div style={{ marginLeft: 15, fontSize: 25 }}>
          {/*  <h3 style={{ marginLeft: 20, marginTop: 5 }}>Orders</h3> */}
          {/*   <h4><b>CONSUMER ORDERS</b></h4> */}
          <hr />
        </div>

        <div style={{ marginTop: 15 }}>
          <div className="row">
            {/*  <div className="containers"> */}
            {/*  <div className="form"> */}
            <div className="inputs-row">
              <div className="input-container" style={{ marginLeft: 20 }}>
                <label className="customer-label">Customer Code</label>
                {/*  <div className="form-label">Order Date</div> */}
                <input
                  type="text"
                  name="CustomerCode"
                  value={cardCustomerCode || ""}
                  onChange={handleChange}
                  className="input-box"
                />
              </div>
              <div style={{ marginTop: "40px" }}>OR</div>
              <div className="input-container">
                <label className="customer-label">Mobile </label>
                <input
                  type="text"
                  name="mobileNo"
                  value={mobileNo || ""}
                  onChange={handleChange}
                  className="input-box"
                />
              </div>
              <div className="button-container">
                <Button className="submit-button" onClick={handleGetButtonClick}>Get</Button>
              </div>
              <div className="dateinput-container">
                <label className="customer-label">Start Date</label>
                <input
                  /*  type="date" */
                  name="date1"
                  value={date1}
                  onChange={handleChange}
                  className="input-box"
                />
              </div>
              <div className="dateinput-container">
                <label className="customer-label">EndDate</label>
                <input
                  /*    type="date" */
                  name="date2"
                  value={date2}
                  onChange={handleChange}
                  className="input-box"
                />
              </div>
              {isCustomerSaved && (
                <div className="col-12 col-md-5" style={{ marginTop: '5px', height: '10px', marginLeft: "end" }}>
                  <pre style={{ fontSize: '15px' }}>{customerList}
                    <Button className="edit-button" style={{ marginLeft: "15px" }} onClick={handleGetButtonClick}>Edit</Button>
                  </pre>
                </div>
              )}
            </div>
          </div>

          {/* Layout for Left and Right Grids */}
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            {/* Left Side Grid - Initially hidden until "Get" button is clicked */}
            <div
              style={{
                flex: '0 0 62%',
                marginRight: '10px',
                visibility: isGetClicked ? 'visible' : 'hidden',
                height: isGetClicked ? 'auto' : '0px',
                overflow: 'hidden', // Hide content when left grid is not visible
              }}
            >
              {isGetClicked && (

                <div>

                  {/* Left Grid */}
                  <div style={{ display: 'flex', }}>
                    <div className="no-border-left-grid" style={{ flex: '0 0 100%' }}>
                      {loadingDetails ? (
                        <p>Loading...</p>
                      ) : (
                        <div>
                          {showGrid && (
                            <div className="table-container">
                              <table className="cardproduct-table">
                                <thead>
                                  <tr>
                                    <th>Code</th>
                                    <th>Product</th>
                                    <th>Rate</th>
                                    <th>Mor Qty/Pkts</th>
                                    <th>Eve Qty/Pkts</th>
                                    <th>Amount</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {fetchedCardProductList
                                    .sort((a, b) => {
                                      // First, sort by mainGroupId
                                      if (a.mainGroupId !== b.mainGroupId) {
                                        console.log("Sorting by mainGroupId:", a.mainGroupId - b.mainGroupId);
                                        return a.mainGroupId - b.mainGroupId;
                                      }

                                      // If mainGroupId is the same, then sort by subGroupId
                                      if (a.subGroupId !== b.subGroupId) {
                                        console.log("Sorting by subGroupId:", a.subGroupId - b.subGroupId);
                                        return a.subGroupId - b.subGroupId;
                                      }

                                      // If both mainGroupId and subGroupId are the same, sort by unitQty
                                      console.log("Sorting by unitQty:", a.unitQty - b.unitQty);
                                      return a.unitQty - b.unitQty;
                                    })
                                    .map((product, index) => (
                                      <tr key={index}>
                                        <td>{product.code}</td>
                                        <td>{product.productName}</td>
                                        <td>₹ {product.rate?.basicRate.toFixed(2)}</td>
                                        <td>
                                          <input
                                            type="number"
                                            value={product.morningQty === 0 ? "" : product.morningQty}
                                            onChange={(e) => handleQtyChange(e, index, 'morningQty')}
                                            className="qty-input"
                                            onInput={(e: React.FormEvent<HTMLInputElement>) => {
                                              const inputValue = (e.target as HTMLInputElement).value;
                                              // Limit the input to 5 digits
                                              if (inputValue.length > 4) {
                                                (e.target as HTMLInputElement).value = inputValue.slice(0, 4);
                                              }
                                            }}
                                            style={{ borderColor: product.productColor, width: 100, padding: 2, textAlign: "right" }}
                                          />
                                        </td>
                                        <td>
                                          <input
                                            type="number"
                                            value={product.eveningQty === 0 ? "" : product.eveningQty}
                                            onChange={(e) => handleQtyChange(e, index, 'eveningQty')}
                                            className="qty-input"
                                            onInput={(e: React.FormEvent<HTMLInputElement>) => {
                                              const inputValue = (e.target as HTMLInputElement).value;
                                              // Limit the input to 5 digits
                                              if (inputValue.length > 4) {
                                                (e.target as HTMLInputElement).value = inputValue.slice(0, 4);
                                              }
                                            }}
                                            style={{ borderColor: product.productColor, width: 100, padding: '2px', textAlign: "right" }}
                                          />
                                        </td>

                                        <td>₹ {product.amount.toFixed(2)}</td>
                                      </tr>
                                    ))}
                                </tbody>
                              </table>
                            </div>
                          )}
                          {!showGrid && <div style={{
                            marginTop: "15px",
                            fontSize: "16px",
                            color: "#555",
                            fontWeight: "bold",
                            textAlign: "center"
                          }}>No data available</div>}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="rows" style={{ marginTop: 30 }}>
                    <div className="col-4">
                      <div className="form-label">Payment Mode</div>
                      <select
                        value={modeOfPayment}
                        onChange={handleModedropdownChange}
                        className="input"
                        style={{ width: '155px' }}  // Adjust the width to your liking
                      >
                        <option value="">Please Select</option>
                        {modePayment.map((option) => (
                          <option key={option.label} value={option.value}>
                            {option.label}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="col-2">
                      <div className="form-label" style={{ marginLeft: -80 }}>Reference No</div>
                      <input
                        name="reference"
                        className="referenceText"
                        value={reference}
                        onChange={handleChange}
                        style={{ width: '175px' }}
                      />
                    </div>

                    <div className="col-2">
                      <div className="form-labels" style={{ marginLeft: -20 }}>Received Amount</div>
                      <input
                        name="receivedAmount"
                        style={{ width: '160px' }}
                        value={receivedAmount}
                        onChange={handleChange}
                        className="inputReceived"
                      />
                    </div>
                    <div className="col-4">
                      <div style={{ textAlign: 'right', fontSize: "15px", paddingRight: "82px" }}>
                        <b>Total: {`₹ ${totalAmount.toFixed(2)}`}</b>
                      </div>
                      <div style={{ textAlign: 'right', fontSize: "17px", paddingRight: '45px', paddingTop: '3px' }}>
                        <Button className="btnPayStyle" onClick={handleConfirmOrder}
                          style={{ minWidth: '210px', textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden', display: 'inline-block' }}>
                          Pay {`₹ ${totalAmount.toFixed(2)}`}
                        </Button>
                      </div>
                    </div>
                  </div>
                  <div className="row" style={{ marginTop: 27 }}>
                    {/* First Column (Agent List) - 75% */}
                    {isBoothSaved && (
                      <div className="col-12" style={{ textAlign: 'left', fontSize: "14px" }}>
                        <div className="agentcontainer">
                          <div className="agent-info-container">
                            {agentList}
                          </div>
                          <Button className="changebutton" onClick={handleChangeBooth}>Change Booth</Button>
                        </div>
                      </div>
                    )}


                    {showContainer && (
                      <div className="modalbooth-backdrop">
                        <div className="modalbooth-container">
                          <div className="modalbooth-header">
                            <h4>Change Booth</h4>
                            <button className="close-button" onClick={handleClose}>X</button>
                          </div>
                          <hr className="boothdivider" />

                          <div className="row">
                            <div className="col-6">
                              <div className="input-boothcontainer">Customer Code</div>
                              <input
                                name="cardCustomerCode"
                                className="boothCode"
                                value={cardCustomerCode}
                                onChange={handleChange}
                              />
                            </div>

                            <div className="col-6">
                              <div className="form-labels">Customer Name</div>
                              <input
                                name="cardCustomerName"
                                value={cardCustomerName}
                                onChange={handleChange}
                                className="inputReceived"
                              />
                            </div>

                          </div>

                          {/*  <hr className="boothdivider"></hr> */}
                          <div className="col-4">
                            <div className="form-label" style={{ marginLeft: "-5px", marginTop: "10px" }}>Booth</div>
                            <select
                              value={droppingPoint}
                              onChange={handledroppingpointdropdownChange}
                              className="input"
                              style={{ width: '205px', marginLeft: "-3px" }}  // Adjust the width to your liking
                            >
                              <option value="">Please Select</option>
                              {dropingPointData.map((option) => (
                                <option key={option.value} value={option.value}>
                                  {option.label}
                                </option>
                              ))}
                            </select>
                          </div>
                          <div className="modalbooth-footer">
                            <button className="save-button" onClick={handleBoothUpdate}>Save</button>
                            {/*  <button className="cancel-button" onClick={handleClose}>Cancel</button> */}
                          </div>
                        </div>
                      </div>
                    )}

                  </div>
                  {/* Modal for Order Confirmation */}
                  <Modal style={{ alignContent: "center" }} show={showModal} onHide={handleCloseModal}>
                    <Modal.Header closeButton>
                      <Modal.Title>Order Confirmation</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <h6>Are you sure you want to confirm the order?</h6>
                      <p>Total Amount: ₹ {totalAmount.toFixed(2)}</p>
                    </Modal.Body>
                    <Modal.Footer>
                      <Button variant="secondary" onClick={handleCloseModal}>
                        Back
                      </Button>
                      <Button
                        variant="primary"
                        onClick={handleProceedOrder}
                        disabled={loadingDetails}
                      >
                        {loadingDetails ? (
                          <>
                            <span className="spinner-inline" /> Processing...
                          </>
                        ) : (
                          'Proceed'
                        )}
                      </Button>
                      {/*  <Button variant="primary" onClick={handleProceedOrder}>
                        Proceed
                      </Button> */}
                    </Modal.Footer>
                  </Modal>
                </div>
              )}
            </div>

            <div style={{ flex: '0 0 38%', height: '280px', marginRight: '650px', marginLeft: '-60px', marginTop: 10 }}>
              <div>
                {/*   <div className="grid"> */}

                <div className="container">

                  <div className="summary-row">

                    <div><b>{zoneData?.name || 'Loading...'}</b></div>
                  </div>
                  <div className="summary-row">
                    <div><span>{orderDate1}</span>                 <span>Total Amount - </span><b> ₹{totalOrderAmount}</b>                                <span>Count:</span> {orderCount} </div>
                  </div>

                  {/*  <div className="summary-row">
                    <div><span>Wallet Amount Used - </span> ₹{walletAmountUsed}</div>
                  </div> */}
                  {/* Horizontal Line Divider */}
                  <hr className="divider" />

                  {/* Table displaying order details */}
                  <table className="order-table">
                    <thead>
                      <tr>
                        <th>Date</th>
                        <th>Customer</th>
                        {/*  <th>B.Name</th> */}
                        <th>Amount</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {orderHistoryList.map((item, index) => (
                        <tr key={index}>
                          <td>{item.receiptDate}</td>
                          <td>{item.cardCustomerCode} - {item.cardCustomerName}</td>
                          {/* <td>{item.droppingPointName}</td> */}
                          <td>₹{item.receiptAmount}</td>
                          <button
                            className="action-btns k-grid-edit-command"
                            onClick={() => handleEdit(item)}
                          >
                            <EditIcon></EditIcon>{' '}
                            {/* <img src={iconEdit} alt="edit" title="Edit" /> */}
                          </button>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            {/* Container for Change Booth */}



          </div>
        </div>
        {/* Back Button */}
        <div className="mt-3" style={{ marginLeft: '20px' }}>
          <button
            className="btn btn-primary btn-sm"
            style={{ height: '36px', marginTop: '20px' }}
            onClick={() => setActivePage("list")}  // Changed from "agentliterorderpage" to "list"
          >
            ← Back
          </button>
        </div>
      </>
    )
  );
}
export default CardOrderEntryPage;
